// extracted by mini-css-extract-plugin
export default {"root":"AskTeacherDetail_root__PhHd+"};